export enum Status {
    active = 'Active',
    inactive = 'Inactive'
}

export enum UserType {
    admin = 'Admin',
    employee = 'Employee',
    safety = 'Safety',
    areaInCharge = 'AreaInCharge'
}

export enum Answer {
    true =  'YES',
    false = 'NO'
}

export enum SignatureType {
    workPermitApprovalSignature = 'workPermitApprovalSignature', // first tab first
    workPermitClosureSignature = 'workPermitClosureSignature', // first tab second
    checkListApprovalRequest = 'checkListApprovalRequest',
    safetyOfficerApprovalRequest = 'safetyOfficerApprovalRequest',
    inchargeSignatureApprovalRequest = 'inchargeSignatureApprovalRequest',
    jobSafetySignatureRequest = 'jobSafetySignatureRequest'
}

export enum  SignatureTypeConstant {
    AreaInChargeSAVWApproval = 'AreaInChargeSAVWIPL',
    SAVWIPLResponsibleExecutionApproval = 'SAVWIPLResponsibleExecution',
    AreaInChargeSAVWClosure = 'AreaInChargeSAVW',
    SAVWIPLResponsibleExecutionClosure = 'SAVWIPLResponsibleExecution',
    VWResponsibleExecution = 'VWResponsibleExecution',
    SAVWExeInCharge=  'SAVWIPLResponsibleExecution',
    SAVWAreaInCharge = 'AreaInChargeSAVWIPL',
    SAVWSafety = 'SAVWSafety'
}

export enum ActionType {
    save =  'save',
    submit = 'submit'
}

export enum HotWorkPermitSignatureType{
    contractorApprovalSignature = 'contractorApprovalSignature',
    contractorClosureSignature = 'contractorClosureSignature',
    contractorViolationSignature = 'contractorViolationSignature',
}
export enum ColdWorkPermitSignatureType{
    contractorApprovalSignature = 'contractorApprovalSignature',
    contractorClosureSignature = 'contractorClosureSignature',
    contractorViolationSignature = 'contractorViolationSignature',
}